import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7c191c24"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pophead"
};
const _hoisted_2 = {
  class: "phleft"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-close"
}, null, -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "popcontent"
};
const _hoisted_7 = {
  class: "popconleft"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "popconright"
};
const _hoisted_10 = {
  class: "innerbox"
};
const _hoisted_11 = {
  class: "imgcontent"
};
const _hoisted_12 = {
  class: "swiper-wrapper"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "textcontainer"
};
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = {
  class: "otherdesc"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-location1"
}, null, -1));
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-tel"
}, null, -1));
const _hoisted_21 = {
  class: "innerbox"
};
const _hoisted_22 = {
  key: 0,
  class: "ul2"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  href: "javascript:void(0)"
};
const _hoisted_25 = {
  class: "imgbox"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "innerdetail"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-close"
}, null, -1));
const _hoisted_29 = [_hoisted_28];
const _hoisted_30 = {
  class: "videobox"
};
const _hoisted_31 = ["src"];
const _hoisted_32 = {
  key: 1,
  class: ""
};
const _hoisted_33 = {
  class: "innerbox"
};
const _hoisted_34 = {
  key: 0,
  class: "ul1"
};
const _hoisted_35 = {
  class: "audiobox"
};
const _hoisted_36 = {
  key: 1,
  class: ""
};
const _hoisted_37 = {
  class: "innerbox"
};
const _hoisted_38 = {
  key: 0,
  class: "ul1"
};
const _hoisted_39 = ["onClick"];
const _hoisted_40 = {
  href: "javascript:void(0)"
};
const _hoisted_41 = {
  class: "textover"
};
const _hoisted_42 = {
  class: "bottomdiv"
};
const _hoisted_43 = {
  class: "innerdetail"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-close"
}, null, -1));
const _hoisted_45 = [_hoisted_44];
const _hoisted_46 = ["innerHTML"];
const _hoisted_47 = {
  key: 1,
  class: ""
};
const _hoisted_48 = {
  class: "innerbox"
};
const _hoisted_49 = {
  key: 0,
  class: "typeul"
};
const _hoisted_50 = ["onClick"];
const _hoisted_51 = ["src"];
const _hoisted_52 = {
  key: 1,
  class: "ul2"
};
const _hoisted_53 = ["onClick"];
const _hoisted_54 = {
  href: "javascript:void(0)"
};
const _hoisted_55 = {
  class: "imgbox"
};
const _hoisted_56 = ["src"];
const _hoisted_57 = {
  class: "innerdetail"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-close"
}, null, -1));
const _hoisted_59 = [_hoisted_58];
const _hoisted_60 = ["innerHTML"];
const _hoisted_61 = {
  key: 2,
  class: ""
};
const _hoisted_62 = {
  class: "innerbox"
};
const _hoisted_63 = {
  key: 0,
  class: "ul2"
};
const _hoisted_64 = ["onClick"];
const _hoisted_65 = {
  href: "javascript:void(0)"
};
const _hoisted_66 = {
  class: "imgbox"
};
const _hoisted_67 = ["src"];
const _hoisted_68 = {
  class: "innerdetail"
};
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-close"
}, null, -1));
const _hoisted_70 = [_hoisted_69];
const _hoisted_71 = {
  class: "videobox"
};
const _hoisted_72 = ["src"];
const _hoisted_73 = ["innerHTML"];
const _hoisted_74 = {
  key: 1,
  class: ""
};
const _hoisted_75 = {
  class: "funbox"
};
const _hoisted_76 = {
  key: 0,
  class: "li4"
};
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-home"
}, null, -1));
const _hoisted_78 = {
  key: 1,
  class: "li2"
};
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-360"
}, null, -1));
const _hoisted_80 = {
  key: 2,
  class: "li3"
};
const _hoisted_81 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-topic"
}, null, -1));
const _hoisted_82 = {
  key: 3,
  class: "li1"
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-location"
}, null, -1));
const _hoisted_84 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_vue_audio = _resolveComponent("vue-audio");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["popcontainer-style3", `width${_ctx.$attrs.bodywidth}`])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$attrs.detail.placeName), 1)]), _createElementVNode("div", {
    class: "closediv",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closePop && $options.closePop(...args))
  }, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.popLeftArr, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass([{
        'active': $data.popLeftIndex === item.id
      }, {
        'no': item.id === 1 && $data.fid !== '10408'
      }]),
      key: index,
      onClick: $event => $options.popLeftHandle(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_8);
  }), 128))])]), _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: _normalizeClass(["swiper-container swiperbox visibleitem", {
      'on': _ctx.$attrs.detail.currentShowtype === 'banner'
    }]),
    ref: "swipercontainer"
  }, [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.banner, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl)
    }, null, 8, _hoisted_13), _createElementVNode("h4", null, [_createElementVNode("span", null, _toDisplayString(i + 1), 1), _createTextVNode("/"), _createElementVNode("span", null, _toDisplayString(_ctx.$attrs.detail.banner.length), 1)])]);
  }), 128))])], 2)], 512), [[_vShow, _ctx.$attrs.detail.banner && _ctx.$attrs.detail.banner.length > 0]]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
    class: "infodesc",
    innerHTML: _ctx.$attrs.detail.introduce
  }, null, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, [_ctx.$attrs.detail.address14 !== undefined && _ctx.$attrs.detail.address14 !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_17, [_hoisted_18, _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.address14), 1)])) : _createCommentVNode("", true), _ctx.$attrs.detail.telphone !== undefined && _ctx.$attrs.detail.telphone !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_19, [_hoisted_20, _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.telphone), 1)])) : _createCommentVNode("", true)])], 512), [[_vShow, $data.popLeftIndex === 0]]), _withDirectives(_createElementVNode("div", _hoisted_21, [_ctx.$attrs.detail.video !== '' ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.video, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.videoItemHandle(item)
    }, [_createElementVNode("a", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("img", {
      src: item.fileUrl,
      alt: ""
    }, null, 8, _hoisted_26)]), _createElementVNode("h2", null, _toDisplayString(item.title), 1)])], 8, _hoisted_23);
  }), 128))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
    class: "closediv",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.closevideoItem && $options.closevideoItem(...args))
  }, _hoisted_29), _createElementVNode("h2", null, _toDisplayString($data.videoitem.title), 1), _createElementVNode("div", _hoisted_30, [_createElementVNode("video", {
    src: $data.videoitem.url,
    controls: ""
  }, null, 8, _hoisted_31)])], 512), [[_vShow, $data.videoitemflag && $data.videoitem !== '']]), _ctx.$attrs.detail.video === '' ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 2]]), _withDirectives(_createElementVNode("div", _hoisted_33, [_ctx.$attrs.detail.audio !== '' ? (_openBlock(), _createElementBlock("ul", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.audio, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, [_createElementVNode("h2", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_35, [_createVNode(_component_vue_audio, {
      file: item.url
    }, null, 8, ["file"])])]);
  }), 128))])) : _createCommentVNode("", true), _ctx.$attrs.detail.audio === '' ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 3]]), _withDirectives(_createElementVNode("div", _hoisted_37, [$data.infoList && $data.infoList.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_38, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.infoList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      onClick: $event => $options.infoItemHandle(item)
    }, [_createElementVNode("a", _hoisted_40, [_createElementVNode("h2", _hoisted_41, _toDisplayString(item.itemformdata[2]), 1), _createElementVNode("div", _hoisted_42, [_createElementVNode("p", null, _toDisplayString(item.itemformdata[3]), 1), _createElementVNode("p", null, _toDisplayString(item.itemformdata[5]), 1)])])], 8, _hoisted_39);
  }), 256))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_43, [_createElementVNode("div", {
    class: "closediv",
    onClick: _cache[2] || (_cache[2] = $event => $data.infoitemflag = false)
  }, _hoisted_45), _createElementVNode("h2", null, _toDisplayString($data.infoitem[2]), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, _toDisplayString($data.infoitem[3]), 1), _createElementVNode("li", null, _toDisplayString($data.infoitem[5]), 1)]), _createElementVNode("div", {
    class: "innerdesc",
    innerHTML: $data.infoitem[6]
  }, null, 8, _hoisted_46)], 512), [[_vShow, $data.infoitemflag && $data.infoitem !== '']]), $data.infoList && $data.infoList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.fid === '10408' && $data.popLeftIndex === 1]]), _withDirectives(_createElementVNode("div", _hoisted_48, [$data.infotypeList && $data.infotypeList.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_49, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.infotypeList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      onClick: $event => $options.infoTypeHandle(item)
    }, [_createElementVNode("img", {
      src: item.image,
      alt: ""
    }, null, 8, _hoisted_51), _createElementVNode("span", null, _toDisplayString(item.name), 1)], 8, _hoisted_50);
  }), 256))])) : _createCommentVNode("", true), $data.infoList && $data.infoList.length > 0 && $data.infoitem === '' ? (_openBlock(), _createElementBlock("ul", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.infoList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      onClick: $event => $options.infoItemHandle(item)
    }, [_createElementVNode("a", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("img", {
      src: item.itemformdata.image,
      alt: ""
    }, null, 8, _hoisted_56)]), _createElementVNode("h2", null, _toDisplayString(item.itemformdata.title), 1)])], 8, _hoisted_53);
  }), 256))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_57, [_createElementVNode("div", {
    class: "closediv",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.closeinfoItem && $options.closeinfoItem(...args))
  }, _hoisted_59), _createElementVNode("h2", null, _toDisplayString($data.infoitem.title), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, _toDisplayString($data.infoitem.category), 1)]), _createElementVNode("div", {
    class: "innerdesc",
    innerHTML: $data.infoitem.content
  }, null, 8, _hoisted_60)], 512), [[_vShow, $data.infoitemflag && $data.infoitem !== '']]), $data.infoList && $data.infoList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 4]]), _withDirectives(_createElementVNode("div", _hoisted_62, [$data.videoList && $data.videoList.length > 0 && $data.videoitem === '' ? (_openBlock(), _createElementBlock("ul", _hoisted_63, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.videoList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      onClick: $event => $options.videoItemHandle(item)
    }, [_createElementVNode("a", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("img", {
      src: item.itemformdata.image,
      alt: ""
    }, null, 8, _hoisted_67)]), _createElementVNode("h2", null, _toDisplayString(item.itemformdata.title), 1)])], 8, _hoisted_64);
  }), 256))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_68, [_createElementVNode("div", {
    class: "closediv",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.closevideoItem && $options.closevideoItem(...args))
  }, _hoisted_70), _createElementVNode("h2", null, _toDisplayString($data.videoitem.title), 1), _createElementVNode("div", _hoisted_71, [_createElementVNode("video", {
    src: $data.videoitem.url,
    controls: ""
  }, null, 8, _hoisted_72)]), _createElementVNode("div", {
    class: "innerdesc",
    innerHTML: $data.videoitem.introduce
  }, null, 8, _hoisted_73)], 512), [[_vShow, $data.videoitemflag && $data.videoitem !== '']]), $data.videoList && $data.videoList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_74, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 5]])])]), _createElementVNode("ul", _hoisted_75, [_ctx.$attrs.detail.portalLink !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_76, [_createElementVNode("a", {
    onClick: _cache[5] || (_cache[5] = $event => $options.goLink(_ctx.$attrs.detail.portalLink)),
    target: "_blank"
  }, [_hoisted_77, _createTextVNode("门户")])])) : _createCommentVNode("", true), _ctx.$attrs.detail.virtualLink !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_78, [_createElementVNode("a", {
    onClick: _cache[6] || (_cache[6] = $event => $options.goLink(_ctx.$attrs.detail.virtualLink)),
    target: "_blank"
  }, [_hoisted_79, _createTextVNode("全景")])])) : _createCommentVNode("", true), _ctx.$attrs.detail.specialLink !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_80, [_createElementVNode("a", {
    onClick: _cache[7] || (_cache[7] = $event => $options.goLink(_ctx.$attrs.detail.specialLink)),
    target: "_blank"
  }, [_hoisted_81, _createTextVNode("专题")])])) : _createCommentVNode("", true), _ctx.$attrs.detail.route !== '' || _ctx.$attrs.detail.location !== undefined && _ctx.$attrs.detail.location !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_82, [_createElementVNode("a", {
    onClick: _cache[8] || (_cache[8] = $event => $options.goLocation(_ctx.$attrs.detail)),
    target: "_blank"
  }, [_hoisted_83, _createTextVNode("导航")])])) : _createCommentVNode("", true)])], 2), [[_vShow, _ctx.$attrs.popshowflag]]), _withDirectives(_createElementVNode("iframe", {
    id: "popiframe",
    src: $data.iframeurl,
    frameborder: "0"
  }, null, 8, _hoisted_84), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createVNode(_component_el_button, {
    class: "goback",
    onClick: $options.goback,
    round: ""
  }, {
    default: _withCtx(() => [_createTextVNode("返回")]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.linkcontainerflag]])]);
}